import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';
import { ContentSearchStatisticsBlock } from '../../_blocks/ContentSearchStatistics';
import { Icons } from '../../components/atoms/SVG';

export type ContentSearchStatisticsWidgetProps = WidgetShape<
  [ContentSearchStatisticsBlock],
  WidgetType.contentsearchstatistics
>;

export function ContentSearchStatisticsWidget({ blocks, ...headerProps }: ContentSearchStatisticsWidgetProps) {
  const { t } = useSonTranslation('ContentSearchStatistics');

  if (isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      icon={Icons.SEARCH_MAGNIFIER}
      widgetType={WidgetType.contentsearchstatistics}
      title={t('widgetTitle')}
    >
      {blocks[0] && <ContentSearchStatisticsBlock {...blocks[0]} />}
    </DefaultWidgetWithHeader>
  );
}
